import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function SoftRepair({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M3.00002 9H21M11 5.995H10.99V5.985L10.98 5.975M8.50002 5.995H8.49002V5.985L8.48002 5.975M6.00002 5.995H5.99002V5.985L5.98002 5.975M21 10.5V6C21 4.34 19.65 3 18 3H6C4.34 3 3 4.34 3 6V18.0003C3 19.6572 4.34315 21 6 21H11M21.0002 18.866C20.8502 19.316 20.5902 19.726 20.2602 20.066C19.0102 21.306 16.9802 21.306 15.7302 20.056C15.5102 19.836 15.3202 19.586 15.1802 19.316M20.81 16.26C19.96 14.7 18.02 14.13 16.46 14.97C16.19 15.11 15.94 15.3 15.72 15.51C15.38 15.84 15.13 16.25 14.98 16.71M19.583 16.2691H20.993V14.8491M16.42 19.3301H15V20.7401" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default SoftRepair;